import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'billingCheck', 'billingMonthly', 'billingAnnual', 'planPrice', 'billingPer'
  ]

  connect () {
    if (this.hasBillingCheckTarget) this.setBillingMode('anual')
  }

  toggleBilling () {
    this.setBillingMode(this.billingCheckTarget.checked ? 'anual' : 'mensual')
  }

  selectMonthly () { this.setBillingMode('mensual') }
  selectAnnual () { this.setBillingMode('anual') }

  setBillingMode (mode) {
    const annual = mode === 'anual'

    this.billingCheckTarget.checked = annual
    this.billingMonthlyTarget.classList.toggle('active', !annual)
    this.billingAnnualTarget.classList.toggle('active', annual)

    this.planPriceTargets.forEach(el => {
      el.textContent = annual ? el.dataset.anual : el.dataset.mensual
    })

    this.billingPerTargets.forEach(el => {
      el.textContent = annual ? el.dataset.anual : el.dataset.mensual
    })
  }
}
